import { Stack, styled } from '@mui/material';

export const StyledTestimonialWrapper = styled(Stack)(() => ({
  alignItems: 'center',
}));
